export enum ESignalFilter {
  ALL = 'ALL',
  FAVOURITE = 'FAVOURITE'
}

export enum ESignalAction {
  BUY = 0,
  SELL = 1
}

export enum ESignalDirection {
  BULLISH = 0,
  BEARISH = 1,
  NEUTRAL = 2
}

export enum ESignalOrderStatus {
  DRAFT = 0,
  EXPIRED = 12,
  BUYSTOP = 15,
  BUYLIMIT = 16,
  LIVETRADE = 9,
  SELLSTOP = 13,
  SELLLIMIT = 14,
  CLOSEDFLAT = 7,
  CLOSEDLOSS = 6,
  CLOSEDPROFIT = 5
}

export const SIGNAL_FILTERS_TABS = [ESignalFilter.FAVOURITE, ESignalFilter.ALL];
